import { render, staticRenderFns } from "./LabelXIcon.vue?vue&type=template&id=b1437f5a&"
import script from "./LabelXIcon.vue?vue&type=script&lang=js&"
export * from "./LabelXIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports